<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Partners</h1>
  <div class="d-flex gap-2">
    <a *isGranted="['ROLE_API_PARTNER_WRITE']" routerLink="add/prospect" class="btn btn-primary fw-bold"><i class="bi bi-plus-lg me-2"></i>Add Prospect</a>
    <a *isGranted="['ROLE_API_PARTNER_WRITE']" routerLink="add/partner" class="btn btn-primary fw-bold"><i class="bi bi-plus-lg me-2"></i>Add Partner</a>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="d-flex gap-3 align-items-center mb-3">
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="filters.values['search']" (change)="filters.onFilterChange()">
        <button class="btn btn-primary" type="button" (click)="filters.onFilterChange()"><i class="bi bi-search"></i></button>
      </div>

      <select class="form-select" (change)="filters.onFilterChange()" [(ngModel)]="filters.values['accountManagerId']">
        <option selected="" value="">Account Manager</option>
        @for (user of users; track user) {
          <option [value]="user.id">{{ user }}</option>
        }
      </select>

      <select class="form-select" (change)="filters.onFilterChange()" [(ngModel)]="filters.values['accountType']">
        <option selected="" value="">Account Type</option>
        <option value="affiliate">Affiliate</option>
        <option value="mediabuy">Media Buy</option>
        <option value="internal">Internal</option>
      </select>

      <app-input-switch [(ngModel)]="filters.values['prospect']" (change)="filters.onFilterChange()">Prospect</app-input-switch>

      <select class="form-select" (change)="filters.onFilterChange()" [(ngModel)]="filters.values['state']">
        <option selected="" value="">All States</option>
        <option value="active">Active</option>
        <option value="pending">Pending</option>
        <option value="rejected">Rejected</option>
        <option value="suspended">Suspended</option>
        <option value="closed">Closed</option>
      </select>

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead class="bg-tertiary">
          <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
            <th>Picture</th>
            <th tableSorterHeader="id">AffID</th>
            <th tableSorterHeader="companyName">Company Name</th>
            <th tableSorterHeader="firstname">First Name</th>
            <th tableSorterHeader="lastname">Last Name</th>
            <th tableSorterHeader="email">Email</th>
            <th tableSorterHeader="lastActivityAt">Last Activity</th>
            <th tableSorterHeader="accountType">Account Type</th>
            <th>Account Manager</th>
            <th tableSorterHeader="state">State</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (partner of partners; track partner) {
            <tr>
              <td>
                <div class="profile-picture">
                  @if (partner.image) {
                    <img [ngSrc]="imageService.getImageUrl(partner.image, 30, 30)" width="30" height="30" class="rounded" alt="Partner profile picture">
                  }
                  @if (!partner.image) {
                    <img ngSrc="/images/oktopus-30px.webp" width="30" height="30" class="rounded" alt="Default profile picture">
                  }
                </div>
              </td>
              <td>{{ partner.prospect ? '-' :  partner.id }}</td>
              <td>{{ partner.companyName }}</td>
              <td>{{ partner.getMainContact().firstname }}</td>
              <td>{{ partner.getMainContact().lastname }}</td>
              <td>{{ partner.email }}</td>
              <td>{{ partner.lastActivityAt ? (partner.lastActivityAt | date: 'yyyy-MM-dd') : '-' }}</td>
              <td>
                <span class="badge" [ngClass]="partner.getAccountTypeClass()">{{ 'partnerAccountType.' + partner.accountType | translate }}</span>
                @if (partner.isMediaBuy() && partner.advertisingPlatform) {
                  <img [ngSrc]="partnerService.getAdvertisingPlatformImage(partner)" alt="" class="logo-regie" width="80" height="22">
                }
              </td>
              <td>{{ partner.accountManager }}</td>
              <td>
                @if (partner.prospect) {
                  <span class="badge bg-warning">Prospect</span>
                }
                @if (!partner.prospect) {
                  <span class="badge" [ngClass]="partner.getStateClass()">{{ 'partnerStatus.' + partner.status | translate }}</span>
                }
              </td>
              <td>
                <button (click)="duplicate(partner)" class="btn btn-secondary me-3" type="button">
                  <i class="bi bi-copy"></i>
                </button>
                @if (partner.id) {
                  <a [routerLink]="[partner.id, 'activity']" class="btn btn-primary">
                    <i class="bi bi-eye-fill"></i>
                  </a>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
